import React from 'react';
import styled from 'styled-components';
import { FaInstagram, FaHeart } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: var(--royal-blue);
  padding: 2rem;
  border-top: 2px solid var(--gold);
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;

  img {
    height: 60px;
    margin-right: 1rem;
  }

  h2 {
    font-family: 'Blackwood Castle', serif;
    font-size: 1.8rem;
    color: var(--gold);
    font-weight: 300;
    position: relative;
    overflow: hidden;
    background: linear-gradient(
      90deg,
      var(--gold) 0%,
      #fffbe6 40%,
      var(--gold) 60%,
      var(--gold) 100%
    );
    background-size: 200% auto;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
    animation: shine var(--shine-duration) linear infinite;

  }
`;

const SocialLinks = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
`;

const SocialLink = styled.a`
  color: var(--gold);
  font-size: 1.5rem;
  margin: 0 1rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: #e1306c;
  }
`;

const FooterText = styled.p`
  color: var(--white);
  text-align: center;
  margin-bottom: 1rem;
  line-height: 1.6;
`;

const Copyright = styled.p`
  color: var(--gold);
  font-size: 0.9rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin: 0 0.5rem;
    color: #c550004d4d;
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo>
          <img src="/images/logolys_web.png" alt="Love Your Skin" />
          <h2>Love Your Skin</h2>
        </FooterLogo>
        
        <SocialLinks>
          <SocialLink href="https://instagram.com/love_your_skin_paris" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </SocialLink>
        </SocialLinks>
        
        <FooterText>
          33 Rue de Cléry, 75002 Paris<br />
          Tel: 01 42 36 07 74<br />
          Email: loveyourskinparis2@gmail.com
        </FooterText>
        
        <Copyright>
          © {currentYear} Love Your Skin. Tous droits réservés. Créé avec <FaHeart /> en France
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
